<script>
import JsonExcel from "vue-json-excel";

export default {
  extends: JsonExcel,
  props: ["data"],
};
</script>
